import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchNoticeOfArrivals(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/notice_of_arrivals', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchNoticeOfArrival(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/notice_of_arrivals/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createNoticeOfArrival(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/notice_of_arrivals', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateNoticeOfArrival(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/notice_of_arrivals/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidNoticeOfArrival(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/notice_of_arrivals/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}